<template>
  <div class="card"  :class="{active: isActive}">
      <div class="card__content" :class="{'card__content--active': isActive}">
          <div class="card__content__icon icon" :class="notNullIcon"/>
          <span class="card__content__label">{{label}}</span>
      </div>
      <div class="card__counter">
        <div class="card__counter__button"
             @click="decrease"
             :class="{'card__counter__button--clickable': value > min}"
        >
          <font-awesome-icon :icon="['fas','minus']" />
        </div>
        <div class="card__counter__value"
             :class="{'card__counter__value--active': isActive}"
        >{{ value }}</div>
        <div class="card__counter__button"
             @click="increase"
             :class="{'card__counter__button--clickable': value < max,
                'card_counter__button--active': isActive}"
        >
          <font-awesome-icon :icon="['fas','plus']" />
        </div>
      </div>
  </div>
</template>

<script>

export default {
  name: 'CardCounter',
  props: {
    value: {
      type: Number,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    isActive() {
      return this.value > 0;
    },
    notNullIcon() {
      return this.icon || 'default';
    },
  },
  methods: {
    increase() {
      if (this.value + this.step <= this.max) {
        this.$emit('input', this.value + this.step);
      }
    },
    decrease() {
      if (this.value - this.step >= this.min) {
        this.$emit('input', this.value - this.step);
      }
    },
  },
};
</script>

<style src="@/assets/scss/furnitures.scss" lang="scss" scoped/>
<style scoped lang="scss">
  .card {
    display: grid;
    border: 1px solid $--color-text-secondary;
    border-radius: $--border-radius-base;
    user-select: none;

    @include breakpoint(mobile){
      grid-template-columns: 100%;
      grid-template-rows: 90px 30px;
    }

    &__content{
      display: flex;
      justify-content: center;
      @include breakpoint(mobile){
        border-bottom: 1px solid $--color-text-secondary;
      }
      &--active{
        border-color: $--color-primary;
      }
      &__label{
        align-self: center;
        text-align: center;
        padding: 4px;
        overflow-wrap: break-word;
        font-size: $--font-size-medium;
        font-weight: $--font-weight-600;
      }
      &__icon{
        display: none;
        align-self: center;
        @include breakpoint(mobile){
          display: unset;
        }
      }
    }

    &__counter{
      display: grid;
      grid-template-columns: 33% 33% 33%;
      color: $--next-dark-blue;
      font-size: 15px;
      place-items: center;

      &__value{
        display: grid;
        place-items: center;
        align-items: center;
        font-family: 'futura-pt-bold', sans-serif;
        text-align: center;
        border: none;
        justify-self: stretch;
        align-self: stretch;
        &--active{
          border-color: $--color-primary;
        }
        @include breakpoint(mobile){
          border-right: 1px solid $--color-text-secondary;
          border-left: 1px solid $--color-text-secondary;
        }
      }
      &__button{
        display: grid;
        place-items: center;
        font-size: 12px;
        width: 100%;
        height: 100%;
        font-family: 'futura-pt-bold', sans-serif;
        &--clickable{
          cursor: pointer;
        }
        svg {
          margin: auto;
        }
      }
    }
  }
  .active{
    background: $--color-primary-light;
    border-color: $--color-primary;
  }
</style>
